import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { MdExpandMore } from 'react-icons/md';
import Button from '../Button';
import { classNames } from '../../utils';
import { FilterLabels } from '..';
import { SelectButtonIcon } from '../SelectButton/SelectButton';
import styles from './FilterDropdown.module.css';
class FilterDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.handleButtonClick = () => {
            const { externalControlOpen, externalControlSetOpen } = this.props;
            if (externalControlOpen === undefined) {
                this.setState((prevState) => {
                    if (!prevState.open) {
                        document.addEventListener('keydown', this.handleKeyPress);
                    }
                    else {
                        document.removeEventListener('keydown', this.handleKeyPress);
                    }
                    return { open: !prevState.open };
                });
            }
            else {
                if (externalControlSetOpen) {
                    externalControlSetOpen(!externalControlOpen);
                }
            }
        };
        this.handleClickOutside = (event) => {
            const { isDatePickerModalOpen, fnToExecuteOnClickOutside } = this.props;
            if (!isDatePickerModalOpen && this.wrapperRef && this.wrapperRef.current) {
                if (this.wrapperRef.current.contains(event.target) === false) {
                    this.close();
                    if (fnToExecuteOnClickOutside !== undefined) {
                        fnToExecuteOnClickOutside();
                    }
                }
            }
        };
        this.handleKeyPress = (event) => {
            if (event.keyCode === 27) {
                this.close();
            }
        };
        this.close = () => {
            const { externalControlOpen, externalControlSetOpen } = this.props;
            document.removeEventListener('keydown', this.handleKeyPress);
            if (externalControlOpen === undefined) {
                this.setState(() => ({ open: false }));
            }
            else {
                externalControlSetOpen && externalControlSetOpen(false);
            }
        };
        this.attachCloseFn = (children) => React.Children.map(children, (child) => {
            // recursively search for dropdown items to attach close functions to them
            if (child !== null && child.type === 'div') {
                return child.props.children
                    ? React.cloneElement(child, {
                        children: this.attachCloseFn(child.props.children),
                    })
                    : child;
            }
            return child !== null && child.type !== 'div'
                ? React.cloneElement(child, { close: this.close })
                : child;
        });
        this.state = {
            open: false,
        };
        this.wrapperRef = React.createRef();
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    render() {
        var _a;
        const { open } = this.state;
        const { className, buttonClassName, dropdownClassName, children, title, filterLabels, icon = _jsx(MdExpandMore, { size: 16, className: styles.arrowIcon }, void 0), size = 'regular', secondary, disabled, alignItemsRight = false, active = false, roundedCorners = true, variant = 'button', externalControlOpen, } = this.props;
        const isReallyOpen = externalControlOpen === undefined ? open : externalControlOpen;
        const displayedTitle = filterLabels ? (_jsx(FilterLabels, { selectedItems: filterLabels.selectedItems, title: filterLabels.title, transformItemName: filterLabels.transformItemName, removeFilter: filterLabels.removeFilter }, void 0)) : title;
        return (_jsxs("div", Object.assign({ className: classNames(className, styles.wrapper, isReallyOpen ? styles.activeWrapper : '', disabled ? styles.disabled : '', active ? styles.selected : '', !isReallyOpen && !disabled && !active ? styles.inactiveWrapper : ''), ref: this.wrapperRef }, { children: [variant === 'button' && (_jsxs(Button, Object.assign({ className: classNames(styles.button, ((_a = filterLabels === null || filterLabels === void 0 ? void 0 : filterLabels.selectedItems) === null || _a === void 0 ? void 0 : _a.length) ? styles.dropdownButtonWithSelectedItems : '', buttonClassName), roundedCorners: roundedCorners, onClick: this.handleButtonClick, variant: secondary ? 'text' : 'outlined', disabled: disabled }, { children: [displayedTitle, icon !== undefined && _jsx("div", Object.assign({ className: styles.icon }, { children: icon }), void 0)] }), void 0)), variant === 'custom' && (_jsx("div", Object.assign({ onClick: disabled ? undefined : this.handleButtonClick }, { children: displayedTitle }), void 0)), variant !== 'button' && variant !== 'custom' && (_jsxs("div", Object.assign({ className: classNames(styles.selectButtonWrapper, buttonClassName), onClick: disabled ? undefined : this.handleButtonClick }, { children: [_jsx(SelectButtonIcon, { disabled: disabled }, void 0), _jsx("div", Object.assign({ className: className }, { children: displayedTitle }), void 0)] }), void 0)), isReallyOpen && (_jsx("div", Object.assign({ className: classNames(dropdownClassName, styles.dropDownWrapper, styles[size], alignItemsRight ? styles.alignRight : '') }, { children: children && this.attachCloseFn(children) }), void 0))] }), void 0));
    }
}
export default FilterDropdown;
